import { render } from "./TaiXeBaoDuongPage.vue?vue&type=template&id=3e7c2c60&scoped=true"
import script from "./TaiXeBaoDuongPage.vue?vue&type=script&lang=js"
export * from "./TaiXeBaoDuongPage.vue?vue&type=script&lang=js"

import "./TaiXeBaoDuongPage.vue?vue&type=style&index=0&id=3e7c2c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7c2c60"]])

export default __exports__